import { Button } from '@/components/ui/button';
import { RefreshCw } from 'lucide-react';
import { TooltipProvider, Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export function EarlyWarningActions() {
  return (
    <div className="flex items-center gap-2">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="sm"
              className="gap-2"
            >
              <RefreshCw className="h-4 w-4" />
              Clear Form
            </Button>
          </TooltipTrigger>
          <TooltipContent>Clear form data</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}